import {
    CREATING_MARKETO_FORM_REQUEST, CREATING_MARKETO_FORM_SUCCEDDED, CREATING_MARKETO_FORM_FAILED,
    UPDATING_MARKETO_FORM_REQUEST, UPDATING_MARKETO_FORM_SUCCEEDED, UPDATING_MARKETO_FORM_FAILED,
    DELETING_MARKETO_FORM_REQUEST, DELETING_MARKETO_FORM_SUCCEEDED, DELETING_MARKETO_FORM_FAILED
} from 'constants/actionTypes';

import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { createAction } from 'redux-actions';
import buildUrl from 'build-url';

const apiUrl = `${process.env.REACT_APP_CLEVERSTORY_API_URL}/api/1.0`;
const MARKETO_FORM_URL = `${apiUrl}/forms/marketo`;

/*
* Create Marketo Form
*/
export const createMarketoForm = createAction(CREATING_MARKETO_FORM_REQUEST, (request) => {
    return {
        request: request
    };
})

const creatingMarketoFormSucceeded = createAction(CREATING_MARKETO_FORM_SUCCEDDED, (response) => {
    return response;
})

const creatingMarketoFormFailed = createAction(CREATING_MARKETO_FORM_FAILED, (error) => {
    return error;
})

function* createMarketoFormSaga(action) {
    const { request } = action.payload;

    const createMarketoFormAPI = () => {
        return axios.post(MARKETO_FORM_URL, request).then(response => response.data);
    }

    try {
        const response = yield call(createMarketoFormAPI);
        if (response) {
            yield put(creatingMarketoFormSucceeded(response));
        }
    } catch (error) {
        yield put(creatingMarketoFormFailed(error));
    }
}


/**
 * Update Marketo form
 */
export const updateMarketoForm = createAction(UPDATING_MARKETO_FORM_REQUEST, (request) => {
    return {
        request: request
    }
})

const updatingMarketoFormSucceeded = createAction(UPDATING_MARKETO_FORM_SUCCEEDED, (response) => {
    return response;
})

const updatingMarketoFormFailed = createAction(UPDATING_MARKETO_FORM_FAILED, (error) => {
    return {
        error: error
    }
})

function* updateMarketoFormSaga(action) {
    const { request } = action.payload;

    const updateMarketoFormAPI = () => {
        return axios.put(MARKETO_FORM_URL, request).then(response => response.data);
    }

    try {
        const response = yield call(updateMarketoFormAPI);
        yield put(updatingMarketoFormSucceeded(response));
    } catch (error) {
        yield put(updatingMarketoFormFailed(request.formId, error));
    }
}


/**
 * Delete Marketo form
 */
export const deleteMarketoForm = createAction(DELETING_MARKETO_FORM_REQUEST, (type, formId) => {
    return {
        type: type,
        formId: formId
    }
})

const deletingMarketoFormSucceeded = createAction(DELETING_MARKETO_FORM_SUCCEEDED, (type, formId) => {
    return {
        type: type,
        formId: formId
    }
})

const deletingMarketoFormFailed = createAction(DELETING_MARKETO_FORM_FAILED, (type, formId, error) => {
    return {
        type: type,
        formId: formId,
        error: error
    }
})

function* deleteMarketoFormSaga(action) {
    const { type, formId } = action.payload;

    const params = {
        formId: formId
    };

    let url = buildUrl(MARKETO_FORM_URL, {
        queryParams: params
    });

    const deleteMarketoFormAPI = () => {
        return axios.delete(url).then(response => response.data);
    }

    try {
        const response = yield call(deleteMarketoFormAPI);
        yield put(deletingMarketoFormSucceeded(type, formId));
    } catch (error) {
        yield put(deletingMarketoFormFailed(type, formId, error));
    }
}

export default function* marketoFormsSaga() {
    yield takeEvery(CREATING_MARKETO_FORM_REQUEST, createMarketoFormSaga)
    yield takeEvery(UPDATING_MARKETO_FORM_REQUEST, updateMarketoFormSaga)
    yield takeEvery(DELETING_MARKETO_FORM_REQUEST, deleteMarketoFormSaga)
}